<template>
  <content-box class="content__claim" :width="'430px'">
    <!-- 입력 -->
    <div v-if="state === 'input'" class="state__input">
      <i class="icon icon--alert"></i>
      <p class="title">{{ $t('lnb.claimIssue.claim.state.input.title') }}</p>
      <p class="desc">{{ $t('lnb.claimIssue.claim.state.input.desc') }}</p>
      <textarea :placeholder="$t('common.placeHolder.claim')"
                v-model="model"
                @focus="modelError = ''"></textarea>
      <strong class="validation-text" v-if="modelError">{{ $t('common.validationErrorText.claim.required') }}</strong>
      <div class="button--wrap">
        <ui-button @click="$emit('closeLayer')">{{ $t('common.cancel') }}</ui-button>
        <ui-button class="btn__claim" :primary2="true" @click="onClaimSend">{{ $t('common.submit') }}</ui-button>
      </div>
    </div>

    <!-- 접수중 -->
    <div v-else-if="state === 'sending'" class="state__sending">
      <ui-loading-circle>
        <p class="desc">{{ $t('lnb.claimIssue.claim.state.sending.desc') }}</p>
      </ui-loading-circle>
    </div>

    <!-- 접수 완료 -->
    <div v-else-if="state === 'success'" class="state__success">
      <i class="icon icon--check-green-size50"></i>
      <p class="title">{{ $t('lnb.claimIssue.claim.state.success.title') }}</p>
      <p class="desc">{{ $t('lnb.claimIssue.claim.state.success.desc') }}</p>
      <ui-button @click="$emit('closeLayer')">{{ $t('common.confirm') }}</ui-button>
    </div>

    <!-- 접수 실패 -->
    <div v-else class="state__fail">
      <i class="icon icon--alert"></i>
      <p class="title">{{ $t('lnb.claimIssue.claim.state.fail.title') }}</p>
      <p class="desc">{{ $t('lnb.claimIssue.claim.state.fail.desc') }}</p>
      <ui-button @click="$emit('closeLayer')">{{ $t('common.confirm') }}</ui-button>
    </div>

  </content-box>
</template>

<script>
import { reportProblem } from '@/api/apply'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle.vue'

export default {
  components: {
    ContentBox,
    UiButton,
    UiLoadingCircle
  },
  data () {
    return {
      model: '',
      modelError: '',
      state: 'input'
    }
  },
  methods: {
    onClaimSend () {
      if (!this.model.length) {
        this.modelError = 'required'
        return false
      }

      this.state = 'sending'

      let param = {
        aid: this.$route.params.aid,
        url: location.href,
        content: this.model
      }

      reportProblem(param).then(() => {
        this.state = 'success'
      }).catch(() => {
        this.state = 'error'
      })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.content__claim {
  text-align: center;

  & > div {
    padding: 50px 30px 25px;
    box-sizing: border-box;
  }

  .title {
    font-size: 20px;
    font-weight: 600;
    color: #444444;
    margin-top: 15px;
  }
  .desc {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;
    margin-top: 12px;
    font-weight: 400;
  }

  .state__input {
    textarea {
      font-size: 14px;
      display: block;
      width: 100%;
      padding: 12px;
      border: 1px solid #dcdcdc;
      height: 200px;
      margin-top: 20px;
      border-radius: 6px;
      resize: none;
      text-align: left;
      box-sizing: border-box;
    }
    .button--wrap {
      margin-top: 20px;
      .btn__claim {
        margin-left: 5px;
      }
    }
    .validation-text {
      @include validErrorText;
      position: absolute;
      left: 42px;
      bottom: 96px;
    }
  }

  .state__sending {
    height: 290px;

    /deep/ .loading p {
      font-size: 14px;
      line-height: 1.43;
      color: #2f2f2f;
      font-weight: 400;
    }
  }

  .state__success {
    .ui-btn {
      margin-top: 40px;
    }
  }

  .state__fail {
    .ui-btn {
      margin-top: 60px;
    }
  }
}
</style>
